import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MoneyIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill={ColorEnum.Jet700} height={16} width={16} viewBox="0 0 16 16" {...props}>
            <Path
                fill="currentColor"
                d="M6.683 10.666H7.3c0 .19.07.348.208.476.14.128.303.192.492.192a.703.703 0 0 0 .492-.192.62.62 0 0 0 .208-.476h.666c.179 0 .331-.063.459-.19a.645.645 0 0 0 .192-.476V7.983a.672.672 0 0 0-.192-.483.612.612 0 0 0-.459-.2H7.383v-.566h1.934a.67.67 0 0 0 .491-.21.67.67 0 0 0 .209-.49.673.673 0 0 0-.209-.492.672.672 0 0 0-.491-.208H8.7c0-.19-.07-.345-.208-.468A.722.722 0 0 0 8 4.683a.722.722 0 0 0-.492.183.595.595 0 0 0-.208.468h-.634a.658.658 0 0 0-.483.2.658.658 0 0 0-.2.483v2.017a.63.63 0 0 0 .2.474.672.672 0 0 0 .483.192h1.95v.566H6.684a.67.67 0 0 0-.491.21.67.67 0 0 0-.209.49c0 .19.07.353.209.492a.672.672 0 0 0 .491.208Zm-3.9 2.8a1.53 1.53 0 0 1-1.125-.458 1.528 1.528 0 0 1-.458-1.125V4.117c0-.445.153-.82.458-1.125a1.53 1.53 0 0 1 1.125-.458h10.434c.444 0 .819.152 1.125.458.305.305.458.68.458 1.125v7.766c0 .445-.153.82-.458 1.125a1.53 1.53 0 0 1-1.125.458H2.783Zm0-1.583h10.434V4.117H2.783v7.766Z"
            />
        </Svg>
    )
}

export default MoneyIcon
